$(document).ready(function() {

  //$("button[name='checkout']").attr("disabled", true);
  
  $('body').on( "click", "#agree", function() {
      if ($('#agree').is(':checked')) {
        console.log('checked'),
        $("button[name='checkout']").attr("disabled", false),
        $("button[name='checkout']").text('לסיום קנייה');
      } else {
        console.log('unchecked');
        $("button[name='checkout']").attr("disabled", true),
        $("button[name='checkout']").text('נא לאשר את התקנון');
      }
    });

  $('body').on("click", "button[name='checkout']", function() {
    if ($('#agree').is(':checked')){
      console.log('to checkout'), $(this).submit();
    } else {
      console.log("must approve terms"),
      event.preventDefault(),
      alert('יש לאשר את תנאי השימוש ותקנון האתר')
    }
  });

});



/*******************************************/
/* translate form error messages to Hebrew */
/*******************************************/

window.addEventListener("load", function() {
  var elements = document.querySelectorAll("input[type='email']");
  for (var i = 0; i < elements.length; i++) {
    elements[i].oninvalid = function(e) {
      e.target.setCustomValidity("");
      if (!e.target.validity.valid) {
        e.target.setCustomValidity("נא להקליד כתובת מייל תקינה");
      }
    };
    elements[i].oninput = function(e) {
      e.target.setCustomValidity("");
    };
  }

  var passwordForms = document.querySelectorAll("input[type='password']");
  for (var i = 0; i < passwordForms.length; i++) {
    passwordForms[i].oninvalid = function(e) {
      e.target.setCustomValidity("");
      if (!e.target.validity.valid) {
        e.target.setCustomValidity("נא למלא שדה זה");
      }
    };
    passwordForms[i].oninput = function(e) {
      e.target.setCustomValidity("");
    };
  }

  var textForms = document.querySelectorAll("input[type='text']");
  for (var i = 0; i < textForms.length; i++) {
    textForms[i].oninvalid = function(e) {
      e.target.setCustomValidity("");
      if (!e.target.validity.valid) {
        e.target.setCustomValidity("נא למלא שדה זה");
      }
    };
    textForms[i].oninput = function(e) {
      e.target.setCustomValidity("");
    };
  }

  var textareas = document.querySelectorAll("textarea");
  for (var i = 0; i < textareas.length; i++) {
    textareas[i].oninvalid = function(e) {
      e.target.setCustomValidity("");
      if (!e.target.validity.valid) {
        e.target.setCustomValidity("נא למלא שדה זה");
      }
    };
    textareas[i].oninput = function(e) {
      e.target.setCustomValidity("");
    };
  }
})


